<template>
  <div>
    <div class="Customer" v-if="CmAllianceList.length > 0">
      <div v-for="(item,index) in CmAllianceList" :key="index">
        <div class="card-div" >
          <div class="info-div">
            <span>{{ item.name }}</span>
            <span @click="enter(index)">参与公司</span>
          </div>
          <div class="info-div end">
            <div class="img-div">
              <img class="img" :src="imageUrl+item.pic" alt/>
            </div>
            <span>活动时间:{{ item.startDate }}至{{ item.endDate }}</span>
          </div>
        </div>
        <div class="cardtext" v-if="listshow[index]">
          <div style="width:40%;margin-left:5%;font-size:0.35rem;font-weight: 400;margin-bottom:1%;overflow: hidden;white-space: nowrap;"
               v-for="(num,indexs) in item.merchantUnionStoreInfoEntityList" :key="indexs">
            <span @click="JumpAllianceCard(index,indexs)">{{ num.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class='null' v-else>
      <img class='pic' src="../../../resource/img/pic_coupon_empty.png"/>
      <div>暂无内容</div>
    </div>
  </div>
</template>
<script>
let startDate
let endDate
export default {
  data () {
    return {
      CmAllianceList: [],
      listshow: [],
      urlParam: {
        merId: null,
        uid: null,
        paid: 1,
        activityType: 1
      },
      imageUrl: this.$common.URL,

    }
  },
  created () {
    let that = this
    // 获取路由参数
    that.urlParam.merId = that.$route.query.merId
    that.urlParam.uid = that.$route.query.uid
    that.GetCmAllianceList()
  },
  methods: {
    GetCmAllianceList: function () {
      let that = this
      that.$axios
        .post(
          '/merchant/api/activity/merchant-union-order-usedetail/user/find/union-card/list',
          that.$qs.stringify({
            merId: that.urlParam.merId,
            uid: that.urlParam.uid,
            paid: that.urlParam.paid,
            activityType: that.urlParam.activityType
          })
        )
        .then(response => {
          //获取客户的商家联盟卡信息
          that.CmAllianceList = response.data.data
          for (let index = 0; index < that.CmAllianceList.length; index++) {
            that.CmAllianceList[index].startDate = that.CmAllianceList[index].startDate.split(' ')[0]
            that.CmAllianceList[index].endDate = that.CmAllianceList[index].endDate.split(' ')[0]
          }
          for (let index = 0; index < that.CmAllianceList.length; index++) {
            that.listshow[index] = false
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    enter: function (index) {
      let that = this
      that.$set(that.listshow, index, true)
    },
    leave: function (index) {
      let that = this
      that.$set(that.listshow, index, false)
    },
    JumpAllianceCard: function (index, indexs) {
      let that = this
      let AllianceCard = that.CmAllianceList[index].merchantUnionStoreInfoEntityList[indexs]
      that.$router.push({
        path: '/MerUnionsrViewAlliance',
        query: {
          uid: that.urlParam.uid,
          activityId: AllianceCard.activityId,
          storeId: AllianceCard.storeId
        }
      })
    }
  }
}
</script>

<style scoped>
.Customer {
  width: 100%;
  height: 90vh;
  margin-top: 60px;
  background: rgba(242, 242, 242, 1);
  font-size: 15px;
  color : #fff;
}

.card-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  background: linear-gradient(135deg, rgba(255, 162, 110, 1) 0%, rgba(244, 0, 0, 1) 100%);
  margin: 0 10px;
  border-radius: 10px;
  padding: 10px;
  height: 150px;
  z-index: 2;
}

.card-div .info-div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-div .info-div.end{
  align-items: flex-end;
}

.card-div .info-div .img-div {
  width: 200px;
  height: 100px;
}

.card-div .info-div .img-div > img{
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.cardtext {
  background-color: white;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  color: #8D8D8D;
  padding: 20px 10px 10px 10px;
  margin: -10px 10px 0 10px;
}

.null {
  margin-top: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.null .pic {
  width: 200px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/active/store/MerUnionsrCustomerAlliance.vue